module.exports = {"370302001":"般阳路街道","370302002":"松龄路街道","370302004":"钟楼街道","370302005":"将军路街道","370302102":"昆仑镇","370302104":"岭子镇","370302111":"西河镇","370302112":"龙泉镇","370302113":"寨里镇","370302114":"罗村镇","370302115":"洪山镇","370302116":"双杨镇","370302117":"太河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370302.json
// module id = 1270
// module chunks = 0